import React from "react";
import PropTypes from "prop-types";
import { Label, Input, FormFeedback, TabPane } from "reactstrap";
import CountrySelect from "../../../Components/Common/CountrySelect";

const NaturalClientForm = ({
  activeArrowTab,
  validation,
  handleNext,
  toggleArrowTab,
}) => {
  // Tab 1 - Client Details
  const renderClientDetailsTab = () => (
    <TabPane id="steparrow-gen-info" tabId={1}>
      <div>
        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="name-field" className="form-label">
              First Name
            </Label>
            <Input
              name="name"
              id="name-field"
              className="form-control"
              placeholder="Enter First Name"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.touched.name && validation.errors.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>

          <div className="col-md-6">
            <Label htmlFor="surname-field" className="form-label">
              Last Name
            </Label>
            <Input
              name="surname"
              id="surname-field"
              className="form-control"
              placeholder="Enter Last Name"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.surname || ""}
              invalid={
                validation.touched.surname && validation.errors.surname
                  ? true
                  : false
              }
            />
            {validation.touched.surname && validation.errors.surname ? (
              <FormFeedback type="invalid">
                {validation.errors.surname}
              </FormFeedback>
            ) : null}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="country-field" className="form-label">
              Country
            </Label>
            <CountrySelect validation={validation} />
            {validation.touched.country && validation.errors.country ? (
              <div className="invalid-feedback d-block">
                {validation.errors.country}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <Label htmlFor="region-field" className="form-label">
              Region
            </Label>
            <Input
              name="region"
              id="region-field"
              className="form-control"
              placeholder="Enter Region"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.region || ""}
              invalid={
                validation.touched.region && validation.errors.region
                  ? true
                  : false
              }
            />
            {validation.touched.region && validation.errors.region ? (
              <FormFeedback type="invalid">
                {validation.errors.region}
              </FormFeedback>
            ) : null}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="city-field" className="form-label">
              City
            </Label>
            <Input
              name="city"
              id="city-field"
              className="form-control"
              placeholder="Enter City"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.city || ""}
              invalid={
                validation.touched.city && validation.errors.city ? true : false
              }
            />
            {validation.touched.city && validation.errors.city ? (
              <FormFeedback type="invalid">
                {validation.errors.city}
              </FormFeedback>
            ) : null}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => {
            handleNext();
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Next
        </button>
      </div>
    </TabPane>
  );

  // Tab 2 - Client Location
  const renderClientLocationTab = () => (
    <TabPane id="steparrow-description-info" tabId={2}>
      <div>
        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="postal_code-field" className="form-label">
              Postal Code <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="postal_code"
              id="postal_code-field"
              className="form-control"
              placeholder="Enter Postal Code"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={validation.values.postal_code || ""}
              invalid={
                validation.touched.postal_code && validation.errors.postal_code
                  ? true
                  : false
              }
            />
            {validation.touched.postal_code &&
              validation.errors.postal_code && (
                <FormFeedback type="invalid">
                  {validation.errors.postal_code}
                </FormFeedback>
              )}
          </div>
          <div className="col-md-6">
            <Label htmlFor="address-field" className="form-label">
              Address
            </Label>
            <Input
              name="address"
              id="address-field"
              className="form-control"
              placeholder="Enter Address"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.address || ""}
              invalid={
                validation.touched.address && validation.errors.address
                  ? true
                  : false
              }
            />
            {validation.touched.address && validation.errors.address && (
              <FormFeedback type="invalid">
                {validation.errors.address}
              </FormFeedback>
            )}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="personal_email-field" className="form-label">
              Email
            </Label>
            <Input
              name="personal_email"
              id="personal_email-field"
              className="form-control"
              placeholder="Enter Email"
              type="email"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.personal_email || ""}
              invalid={
                validation.touched.personal_email &&
                validation.errors.personal_email
                  ? true
                  : false
              }
            />
            {validation.touched.personal_email &&
              validation.errors.personal_email && (
                <FormFeedback type="invalid">
                  {validation.errors.personal_email}
                </FormFeedback>
              )}
          </div>

          <div className="col-md-6">
            <Label htmlFor="mobile_phone_number-field" className="form-label">
              Mobile Phone Number
            </Label>
            <Input
              name="mobile_phone_number"
              id="mobile_phone_number-field"
              className="form-control"
              placeholder="Enter Mobile Phone Number"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.mobile_phone_number || ""}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              invalid={
                validation.touched.mobile_phone_number &&
                validation.errors.mobile_phone_number
                  ? true
                  : false
              }
            />
            {validation.touched.mobile_phone_number &&
              validation.errors.mobile_phone_number && (
                <FormFeedback type="invalid">
                  {validation.errors.mobile_phone_number}
                </FormFeedback>
              )}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="land_phone_number-field" className="form-label">
              Landline Phone Number{" "}
              <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="land_phone_number"
              id="land_phone_number-field"
              className="form-control"
              placeholder="Enter Landline Phone Number"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={validation.values.land_phone_number || ""}
            />
          </div>
        </div>
      </div>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            toggleArrowTab(activeArrowTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
          Back
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleNext();
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Next
        </button>
      </div>
    </TabPane>
  );

  // Tab 3 - Client Accounts
  const renderClientAccountsTab = () => (
    <TabPane id="steparrow-final" tabId={3}>
      <div>
        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="profession-field" className="form-label">
              Profession <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="profession"
              id="profession-field"
              className="form-control"
              placeholder="Enter Profession"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.profession || ""}
              invalid={
                validation.touched.profession && validation.errors.profession
                  ? true
                  : false
              }
            />
            {validation.touched.profession && validation.errors.profession ? (
              <FormFeedback type="invalid">
                {validation.errors.profession}
              </FormFeedback>
            ) : null}
          </div>

          <div className="col-md-6">
            <Label htmlFor="passport-field" className="form-label">
              Passport <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="passport"
              id="passport-field"
              className="form-control"
              placeholder="Enter Passport"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.passport || ""}
            />
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label
              htmlFor="social_security_number-field"
              className="form-label"
            >
              Social Security Number
            </Label>
            <Input
              name="social_security_number"
              id="social_security_number-field"
              className="form-control"
              placeholder="Enter Social Security Number"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.social_security_number || ""}
              invalid={
                validation.touched.social_security_number &&
                validation.errors.social_security_number
                  ? true
                  : false
              }
            />
            {validation.touched.social_security_number &&
              validation.errors.social_security_number && (
                <FormFeedback type="invalid">
                  {validation.errors.social_security_number}
                </FormFeedback>
              )}
          </div>

          <div className="col-md-6">
            <Label
              htmlFor="social_security_series-field"
              className="form-label"
            >
              Social Security Series <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="social_security_series"
              id="social_security_series-field"
              className="form-control"
              placeholder="Enter Social Security Series"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.social_security_series || ""}
              invalid={
                validation.touched.social_security_series &&
                validation.errors.social_security_series
                  ? true
                  : false
              }
            />
            {validation.touched.social_security_series &&
            validation.errors.social_security_series ? (
              <FormFeedback type="invalid">
                {validation.errors.social_security_series}
              </FormFeedback>
            ) : null}
          </div>
        </div>

        <div className="mb-3">
          <Label htmlFor="iban_ron-field" className="form-label">
            IBAN (RON) <span className="text-muted">(optional)</span>
          </Label>
          <Input
            name="iban_ron"
            id="iban_ron-field"
            className="form-control"
            placeholder="Enter IBAN (RON)"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.iban_ron || ""}
            invalid={
              validation.touched.iban_ron && validation.errors.iban_ron
                ? true
                : false
            }
          />
        </div>

        <div className="mb-3">
          <Label htmlFor="iban_euro-field" className="form-label">
            IBAN (EUR) <span className="text-muted">(optional)</span>
          </Label>
          <Input
            name="iban_euro"
            id="iban_euro-field"
            className="form-control"
            placeholder="Enter IBAN (EUR)"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.iban_euro || ""}
            invalid={
              validation.touched.iban_euro && validation.errors.iban_euro
                ? true
                : false
            }
          />
        </div>

        <div className="mt-4 mb-3">
          <div className="form-check form-switch">
            <Input
              type="checkbox"
              className="form-check-input"
              id="add_second_client"
              name="add_second_client"
              onChange={validation.handleChange}
              checked={validation.values.add_second_client || false}
            />
            <Label className="form-check-label" htmlFor="add_second_client">
              Add Second Client / Partner
            </Label>
          </div>
        </div>

        {validation.values.add_second_client && (
          <div className="second-client-section">
            <div className="border rounded p-3 mb-3">
              <h5 className="mb-3">Second Client Information</h5>

              <div className="row gy-4 mb-3">
                <div className="col-md-6">
                  <Label
                    htmlFor="additional_contact2_name-field"
                    className="form-label"
                  >
                    First Name
                  </Label>
                  <Input
                    name="additional_contact2_name"
                    id="additional_contact2_name-field"
                    className="form-control"
                    placeholder="Enter First Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.additional_contact2_name || ""}
                    invalid={
                      validation.touched.additional_contact2_name &&
                      validation.errors.additional_contact2_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.additional_contact2_name &&
                  validation.errors.additional_contact2_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.additional_contact2_name}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="col-md-6">
                  <Label
                    htmlFor="additional_contact2_surname-field"
                    className="form-label"
                  >
                    Last Name
                  </Label>
                  <Input
                    name="additional_contact2_surname"
                    id="additional_contact2_surname-field"
                    className="form-control"
                    placeholder="Enter Last Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.additional_contact2_surname || ""}
                    invalid={
                      validation.touched.additional_contact2_surname &&
                      validation.errors.additional_contact2_surname
                        ? true
                        : false
                    }
                  />
                  {validation.touched.additional_contact2_surname &&
                  validation.errors.additional_contact2_surname ? (
                    <FormFeedback type="invalid">
                      {validation.errors.additional_contact2_surname}
                    </FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="row gy-4 mb-3">
                <div className="col-md-6">
                  <Label
                    htmlFor="additional_contact2_ssn-field"
                    className="form-label"
                  >
                    Social Security Number
                  </Label>
                  <Input
                    name="additional_contact2_ssn"
                    id="additional_contact2_ssn-field"
                    className="form-control"
                    placeholder="Enter Social Security Number"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={validation.values.additional_contact2_ssn || ""}
                    invalid={
                      validation.touched.additional_contact2_ssn &&
                      validation.errors.additional_contact2_ssn
                        ? true
                        : false
                    }
                  />
                  {validation.touched.additional_contact2_ssn &&
                  validation.errors.additional_contact2_ssn ? (
                    <FormFeedback type="invalid">
                      {validation.errors.additional_contact2_ssn}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="col-md-6">
                  <Label
                    htmlFor="additional_contact2_ssn_series-field"
                    className="form-label"
                  >
                    Social Security Series <span className="text-muted">(optional)</span>
                  </Label>
                  <Input
                    name="additional_contact2_ssn_series"
                    id="additional_contact2_ssn_series-field"
                    className="form-control"
                    placeholder="Enter Social Security Series"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.additional_contact2_ssn_series || ""
                    }
                    invalid={
                      validation.touched.additional_contact2_ssn_series &&
                      validation.errors.additional_contact2_ssn_series
                        ? true
                        : false
                    }
                  />
                  {validation.touched.additional_contact2_ssn_series &&
                  validation.errors.additional_contact2_ssn_series ? (
                    <FormFeedback type="invalid">
                      {validation.errors.additional_contact2_ssn_series}
                    </FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="row gy-4 mb-3">
                <div className="col-md-6">
                  <Label
                    htmlFor="additional_contact2_mobile-field"
                    className="form-label"
                  >
                    Mobile Phone Number
                  </Label>
                  <Input
                    name="additional_contact2_mobile"
                    id="additional_contact2_mobile-field"
                    className="form-control"
                    placeholder="Enter Mobile Phone Number"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={validation.values.additional_contact2_mobile || ""}
                    invalid={
                      validation.touched.additional_contact2_mobile &&
                      validation.errors.additional_contact2_mobile
                        ? true
                        : false
                    }
                  />
                  {validation.touched.additional_contact2_mobile &&
                  validation.errors.additional_contact2_mobile ? (
                    <FormFeedback type="invalid">
                      {validation.errors.additional_contact2_mobile}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="col-md-6">
                  <Label
                    htmlFor="additional_contact2_email-field"
                    className="form-label"
                  >
                    Email
                  </Label>
                  <Input
                    name="additional_contact2_email"
                    id="additional_contact2_email-field"
                    className="form-control"
                    placeholder="Enter Email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.additional_contact2_email || ""}
                    invalid={
                      validation.touched.additional_contact2_email &&
                      validation.errors.additional_contact2_email
                        ? true
                        : false
                    }
                  />
                  {validation.touched.additional_contact2_email &&
                  validation.errors.additional_contact2_email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.additional_contact2_email}
                    </FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="alert alert-info mt-2">
                <i className="ri-information-line me-2"></i>
                The second client will share the same address as the primary
                client.
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            toggleArrowTab(activeArrowTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
          Back
        </button>
        <button
          type="submit"
          className="btn btn-success btn-label right ms-auto nexttab nexttab"
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Submit
        </button>
      </div>
    </TabPane>
  );

  switch (activeArrowTab) {
    case 1:
      return renderClientDetailsTab();
    case 2:
      return renderClientLocationTab();
    case 3:
      return renderClientAccountsTab();
    default:
      return null;
  }
};

NaturalClientForm.propTypes = {
  activeArrowTab: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
  toggleArrowTab: PropTypes.func.isRequired,
};

export default NaturalClientForm;
